const initialState = {
    pages: 0,
};
/**
 * teporary save the state of passwords if user change his password
 * @param {object} state
 * @param {object} action
 */
const appStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_PAGINATION_PAGES":
            return {
                ...state,
                pages: action.payload.pages,
            };
        case "SET_PATIENT_SUBSCRIPTION":
            return {
                ...state,
                patientSubscription: action.payload.patientSubscription,
            };
        case "SET_PATIENT_PROFILE_DATA":
            return { ...state, profileData: action.payload.profileData };
        default:
            return state;
    }
};

export default appStateReducer;
